// @ts-nocheck
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@store/Framework/Store";
import "@store/Themes";
import "@toolkit/initialize";

// Store Custom Code - In production, Library widgets are lazy-loaded via importChunk.tsx
// (generated by createImportChunk.js). In dev, we load them eagerly for HMR support.
if (!IS_PRODUCTION) {
    const widgets = require.context("./Library/Widgets", true, /\.tsx$/);
    const onHotWidgetReplace = addWidgetsFromContext(widgets);
    if (module.hot) {
        module.hot.accept(widgets.id.toString(), () =>
            onHotWidgetReplace(require.context("./Library/Widgets", true, /\.tsx$/)),
        );
    }
}

// createImportChunk.js skips widget directories named Common/Basic/Header/Footer/SignIn
// (they're eagerly loaded from content-library by LoadComponents.ts). But blueprint widgets
// in those directories are NOT in content-library, so they need to be loaded here.
if (IS_PRODUCTION) {
    const skippedDirWidgets = require.context(
        "./Library/Widgets",
        true,
        /(Common|Basic|Header|Footer|SignIn)\/.+?\.tsx$/,
    );
    addWidgetsFromContext(skippedDirWidgets);

    // Layout-page widgets that live outside skipped dirs (Common/Basic/Header/Footer/SignIn).
    // Without this they'd be lazy via importChunk, adding a round-trip on first paint.
    const layoutWidgets = require.context(
        "./Library/Widgets",
        true,
        /^\.\/(Category|CustomerDetails|LinkCard)\/.+?\.tsx$/,
    );
    addWidgetsFromContext(layoutWidgets);
}

// load all pages. Without this they won't be included in the bundle
const pages = require.context("./Library/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Library/Pages", true, /\.tsx$/)));
}

// load all extensions. They could be loaded individually instead.
const extensions = require.context("./Extensions", true);
extensions.keys().forEach(key => extensions(key));

// In production, widget extensions are included in the lazy chunks created for widgets
// (via createImportChunk.js name-matching). In dev, we load them eagerly for HMR support.
if (!IS_PRODUCTION) {
    const widgetExtensions = require.context("./WidgetExtensions", true);
    widgetExtensions.keys().forEach(key => widgetExtensions(key));
}

/* Store Custom Code - Start */
if (module.hot) {
    // Handler chains can't be safely hot-replaced (addToChainAfter duplicates on re-run),
    // so decline HMR for Store handlers — reload=true on the HMR client handles the rest.
    const storeHandlerContext = require.context("./Extensions/Store", true);
    module.hot.decline(storeHandlerContext.id.toString());

    // Accept extensions context as an HMR boundary. Edits to MobiusOverrides or Overrides
    // (pulled in via BlueprintReplacementPlugin) bubble here. React Fast Refresh patches
    // the component declarations automatically — no need to manually reload widgets/pages.
    module.hot.accept(extensions.id.toString());
}
/* Store Custom Code - End */
